import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import PortalShell from "../components/PortalShell";
import PageWidgetsRenderer from "../components/PageWidgetsRenderer";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

// layout_mode=standalone pages render here -- own top-level route (outside
// PrivateRoute/the admin Dashboard shell). requires_auth (checked server-
// side by GET /pages/:slug/bootstrap) decides whether this needs a login at
// all -- a 401 here means "log in, then come back", not "you're not
// allowed in". Header/footer chrome (PortalShell) is purely data-driven
// from this page's own header_logo_url/header_title/header_color -- set
// the same values on every page in a flow for consistent-looking chrome.
const PortalView = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [bootstrap, setBootstrap] = useState(null);
  const [error, setError] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    let cancelled = false;
    setBootstrap(null);
    setError("");
    axios
      .get(`${API_BASE}/pages/${slug}/bootstrap`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
      .then((res) => {
        if (!cancelled) setBootstrap(res.data);
      })
      .catch((err) => {
        if (cancelled) return;
        if (err?.response?.status === 401) {
          navigate(`/login?redirect=/portal/${slug}`);
          return;
        }
        setError(err?.response?.data?.detail || "Failed to load page.");
      });
    return () => {
      cancelled = true;
    };
  }, [slug, token, navigate]);

  useEffect(() => {
    if (!bootstrap?.page?.auto_redirect_target_slug) return undefined;
    const seconds = bootstrap.page.auto_redirect_after_seconds || 5;
    const timer = setTimeout(() => {
      navigate(`/portal/${bootstrap.page.auto_redirect_target_slug}`);
    }, seconds * 1000);
    return () => clearTimeout(timer);
  }, [bootstrap, navigate]);

  if (error) {
    return (
      <PortalShell>
        <div className="text-red-600">{error}</div>
      </PortalShell>
    );
  }

  if (!bootstrap) {
    return (
      <PortalShell>
        <div className="text-gray-400">Loading…</div>
      </PortalShell>
    );
  }

  const { page } = bootstrap;

  return (
    <PortalShell
      headerLogoUrl={page.header_logo_url}
      headerTitle={page.header_title || page.name}
      headerColor={page.header_color}
      pageTitle={page.name}
    >
      <PageWidgetsRenderer
        widgets={bootstrap.widgets}
        slug={slug}
        basePath="/portal"
        apiBaseUrl={API_BASE}
        token={token}
      />
    </PortalShell>
  );
};

export default PortalView;
